/**
 * RoadmapItemStatus
 *
 * Mirrors Flutter's `RoadmapItemStatus` enum
 * (lib/domain/enums/roadmap_item_status.dart). The ordinal order is
 * load-bearing: a roadmap item document stores `status` as an integer index,
 * and Flutter resolves the label via `RoadmapItemStatus.values[item.status]`.
 * The web equivalent indexes this enum by the same integer, so the ordinal
 * order MUST stay Open(0) → InProgress(1) → Completed(2) → Rejected(3).
 */
export enum RoadmapItemStatus {
  open = 0,
  inProgress = 1,
  completed = 2,
  rejected = 3,
}

/**
 * Maps each status ordinal to an l10n bundle key. The enum stays free of
 * presentation concerns (no English strings live here); the actual labels
 * — Flutter's `"Open"`, `"In progress"`, `"Completed"`, `"Rejected"` — are
 * added to the l10n bundle and resolved in the presentation layer (Task 7).
 *
 * Keyed value→l10n-key only so a wrong ordinal cannot silently mislabel a
 * status: the map is exhaustive over the enum's values.
 */
export const ROADMAP_ITEM_STATUS_LABEL_KEYS: Record<RoadmapItemStatus, string> = {
  [RoadmapItemStatus.open]: 'roadmap.statusOpen',
  [RoadmapItemStatus.inProgress]: 'roadmap.statusInProgress',
  [RoadmapItemStatus.completed]: 'roadmap.statusCompleted',
  [RoadmapItemStatus.rejected]: 'roadmap.statusRejected',
};
